var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationContact(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2,
    width: 78,
    height: 78,
    rx: 39,
    fill: "#467CD2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2,
    width: 78,
    height: 78,
    rx: 39,
    stroke: "#C5DBFF",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 20.875C36.3077 20.8798 32.2885 22.5472 29.3241 25.5116C26.3597 28.476 24.6923 32.4952 24.6875 36.6875C24.6875 50.218 39.0625 60.4368 39.6752 60.8645C39.9169 61.0338 40.2049 61.1246 40.5 61.1246C40.7951 61.1246 41.0831 61.0338 41.3248 60.8645C41.9375 60.4368 56.3125 50.218 56.3125 36.6875C56.3077 32.4952 54.6403 28.476 51.6759 25.5116C48.7115 22.5472 44.6923 20.8798 40.5 20.875ZM40.5 30.9375C41.6372 30.9375 42.7489 31.2747 43.6945 31.9066C44.6401 32.5384 45.3771 33.4364 45.8123 34.4871C46.2475 35.5377 46.3614 36.6939 46.1395 37.8093C45.9177 38.9247 45.37 39.9492 44.5659 40.7534C43.7617 41.5575 42.7372 42.1052 41.6218 42.327C40.5064 42.5489 39.3502 42.435 38.2996 41.9998C37.2489 41.5646 36.3509 40.8276 35.7191 39.882C35.0872 38.9364 34.75 37.8247 34.75 36.6875C34.75 35.1625 35.3558 33.7 36.4341 32.6216C37.5125 31.5433 38.975 30.9375 40.5 30.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationContact);
export default __webpack_public_path__ + "static/media/location-contact.886c5beb2542b00fa71b1a5ae3f02443.svg";
export { ForwardRef as ReactComponent };